module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-3-4f56fbee8f329ff95da533c9beba60b1.jpg";